import type { KeyPortRequestMessage } from '../../types/KeyPortRequestMessage';
import { useToasts } from '../cdl/Toast/useToasts';
import { translate } from '../common/helpers/translate.helper';
import { useRole } from '../common/hooks/useRole';

import { KeyPortForm } from './KeyPortForm';
import { useKeyPortCreate } from './useKeyPortCreate';

interface CreateKeyPortFormProps {
    onSuccess: () => void;
}

export const CreateKeyPortForm = ({ onSuccess }: CreateKeyPortFormProps) => {
    const role = useRole();
    const { addToast, addErrorToast } = useToasts();

    const { mutateAsync: createKeyPort, error } = useKeyPortCreate();
    const handleSubmit = async ({ data }: { data: KeyPortRequestMessage }) => {
        try {
            await createKeyPort(data, {
                onSuccess: () => {
                    addToast(translate('keyPorts.toast.createKeyPort.success'));
                    onSuccess();
                },
                onError: (mutationError) => {
                    if (mutationError.response?.status !== 400) {
                        addErrorToast(translate('keyPorts.toast.createKeyPort.error'));
                    }
                },
            });
        } catch {
            return;
        }
    };

    return (
        <KeyPortForm
            onSubmit={handleSubmit}
            errors={error?.response?.data?.errors}
            data={{
                customerGroupId: !role.isSuperAdmin() ? role.user.groupId : undefined,
            }}
        />
    );
};
